// Types
import { FullCaseResponse } from 'app/modules/cases/responses';

export enum CasesActionTypes {
  RETRIEVE_CASE = '@@cases/RETRIEVE_CASE',
  RETRIEVE_CASE_SUCCESS = '@@cases/RETRIEVE_CASE_SUCCESS',

  EDIT_CASE_SUCCESS = '@@cases/EDIT_CASE_SUCCESS',

  ADD_DOCUMENTS_SUCCESS = '@@cases/ADD_DOCUMENTS_SUCCESS',

  DELETE_DOCUMENT_SUCCESS = '@@cases/DELETE_DOCUMENT_SUCCESS',

  UPLOAD_FILES_SUCCESS = '@@cases/UPLOAD_FILES_SUCCESS',
}

export interface CasesState {
  case: FullCaseResponse;
}
